<template>
  <div>
    <div v-if="responses.total > 0">
      <div v-show="mode == 'pie'">
        <PieChart :chart-data="chartData" />
      </div>
      <div v-show="mode == 'bar'">
        <BarChart :chart-data="chartData" />
      </div>
      <div v-show="mode == 'horizontal'">
        <HorizontalBarChart :chart-data="chartData" />
      </div>
      <b-button icon-right="cached" @click="nextChart" />
    </div>
    <div v-else>
      <div class="has-text-centered">
        <b-icon icon="chart-pie" />
        <br />
        <span>{{ $t("noSurveyResults") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import PieChart from "./PieChart";
import BarChart from "./BarChart";
import HorizontalBarChart from "./HorizontalBarChart";
export default {
  name: "RenderResults",
  components: {
    PieChart,
    BarChart,
    HorizontalBarChart,
  },
  props: {
    question: {
      type: Object,
      default() {
        return {};
      },
    },
    responses: {
      type: Object,
      default() {
        return {};
      },
    },
    serverAnswer: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      mode: "pie", // pie, bar, ...
    };
  },
  computed: {
    chartData() {
      if (
        this.question != null &&
        Object.keys(this.question).length > 0 &&
        this.responses != null &&
        Object.keys(this.responses).length > 0
      ) {
        let question = this.question.question;
        let options = this.question.options;

        let labels = [];
        let data = [];
        let backgroundColor = [];
        let mostVotes = Math.max(...options.map((y, key) => this.responses[key])); // gets the highest number of votes, if two entries have the same amount they get colored the same
        for (let [key, value] of Object.entries(options)) {
          // 20.10.2020 temporary
          labels.push(this.$t(value.text));
          data.push(this.responses[key]);
          if (mostVotes == this.responses[key]) {
            backgroundColor.push("#CCFF23");
          } else {
            backgroundColor.push("#D3D3D3");
          }
        }

        data = {
          labels,
          datasets: [
            {
              label: question,
              data: data,
              backgroundColor: backgroundColor, //["#3366cc","#dc3912","#ff9900","#109618","#990099","#0099c6","#dd4477","#66aa00","#b82e2e","#316395","#994499","#22aa99","#aaaa11","#6633cc","#e67300","#8b0707","#651067","#329262","#5574a6","#3b3eac","#b77322","#16d620","#b91383","#f4359e","#9c5935","#a9c413","#2a778d","#668d1c","#bea413","#0c5922","#743411"],
            },
          ],
        };
        return data;
      }
      return null;
    },
  },
  methods: {
    nextChart() {
      switch (this.mode) {
        case "pie":
          this.mode = "bar";
          break;
        case "bar":
          this.mode = "horizontal";
          break;
        case "horizontal":
          this.mode = "pie";
          break;
        default:
          this.mode = "pie";
      }
    },
  },
};
</script>

<style></style>
